import { GuestRegisterFormModel } from './Models/GuestRegisterFormModel';
import { SecuredClient } from '../../../Core/Api/SecuredClient';
import { SlimUser, ResendOTPCommandRequest, BrokerFilterRequest, OrderBy, ValidateGuestOTPCommandRequest, RegisterGuestCommandRequest, ResumeGuestApplicationCommandRequest, ResumeGuestApplicationCommandResponse } from '../../../Core/Api/Api';

export class GuestRegisterFormHandler {
    props: any;
    constructor(props) {
        this.props = props;
    }

    RequestRegister(RegisterformModel: GuestRegisterFormModel): Promise<SlimUser | undefined> {
        const client = new SecuredClient();
        const request = new RegisterGuestCommandRequest();
        request.init(RegisterformModel);
        client.showLoading = true;
        client.handleGeneralError = true;
        return client.registerGuest(request).then(x => {
            return x.newUser;
        });
    }

    ResendOTP(guestId: string) {
        const client = new SecuredClient();
        const request = new ResendOTPCommandRequest();
        request.guestId = guestId;
        //request.init(RegisterformModel);
        client.showLoading = true;
        client.handleGeneralError = true;
        return client.resendOTP(request);
    }

    ValidateOTP(guestId: string, otp: string): Promise<SlimUser | undefined> {
        const client = new SecuredClient();
        const request = new ValidateGuestOTPCommandRequest();
        request.otp = otp;
        request.guestId = guestId;
        //request.init(RegisterformModel);
        client.showLoading = true;
        client.handleGeneralError = true;
        return client.validateGuestOTP(request).then(x => {
            if (x.user) {
                sessionStorage.setItem('user', JSON.stringify(x.user));
            }
            //return x.user;
            return x.user;
        });
    }

    ResumeGuestApplication(email?: string, appId?: number): Promise<ResumeGuestApplicationCommandResponse | undefined> {
        const client = new SecuredClient();
        const request = new ResumeGuestApplicationCommandRequest();
        request.email = email;
        request.applicationId = appId;
        //request.init(RegisterformModel);
        client.showLoading = true;
        client.handleGeneralError = true;
        return client.resumeGuestApplication(request);
    }

    GetBrokers() {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const request = new BrokerFilterRequest();
        request.amountPerPage = 500;
        request.orderBy = [];
        request.orderBy.push(new OrderBy({ field: 'Name', ascending: true }));

        return client.getBrokers(request);
    }
}






